module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS42NjgiIGhlaWdodD0iMTIuODk5IiB2aWV3Qm94PSIwIDAgMTkuNjY4IDEyLjg5OSI+PHBhdGggZD0iTTE3LjYyOSAxLjg1NGwtNy43NTggOC44NjdtLTcuNzctOC44NTZsNy43NiA4Ljg2NyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNUY4MDhDIiBzdHJva2Utd2lkdGg9IjIuMjAyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/maximize.svg
// module id = 139
// module chunks = 0